var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isLoading ? _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : _c('div', [_c('b-row', {
    staticClass: "mb-3"
  }, [_c('b-col', {
    staticClass: "pt-1",
    attrs: {
      "cols": "5"
    }
  }, [_vm._v(" Vervoerder: ")]), _c('b-col', {
    attrs: {
      "cols": "7"
    }
  }, [_c('b-select', {
    model: {
      value: _vm.carrierId,
      callback: function ($$v) {
        _vm.carrierId = $$v;
      },
      expression: "carrierId"
    }
  }, _vm._l(_vm.carriersForSelectedDispatcherAndDispatchType(_vm.dispatchRequest), function (carrier) {
    return _c('b-select-option', {
      key: carrier.id,
      attrs: {
        "value": carrier.id
      },
      domProps: {
        "textContent": _vm._s(carrier.display_name)
      }
    });
  }), 1)], 1)], 1), _c('b-row', {
    key: _vm.carrierId,
    staticClass: "mb-3"
  }, [_c('b-col', {
    staticClass: "pt-1",
    attrs: {
      "cols": "5"
    }
  }, [_vm._v(" Vervoersmethode: ")]), _c('b-col', {
    attrs: {
      "cols": "7"
    }
  }, [_c('b-select', {
    model: {
      value: _vm.dispatchRequest.carrier_method_id,
      callback: function ($$v) {
        _vm.$set(_vm.dispatchRequest, "carrier_method_id", $$v);
      },
      expression: "dispatchRequest.carrier_method_id"
    }
  }, _vm._l(_vm.availableCarrierMethods, function (carrierMethod) {
    return _c('b-select-option', {
      key: carrierMethod.id,
      attrs: {
        "value": carrierMethod.id
      },
      domProps: {
        "textContent": _vm._s(carrierMethod.display_name)
      }
    });
  }), 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }